module.exports = __webpack_public_path__ + "img/Step04a.f6df07a2.webp";